import * as localStorageKeys from '../../../constants/localStorageKeys';
import { EZLO_PATHS } from '../../Navigation/constants';
import { EZLOGIC, NOTIFICATIONS, MESHBOTS_PAGE_VALUE } from '../EzloCustomization/constants';

export const isPageValue = () => {
    const pageVal = localStorage.getItem(localStorageKeys.PAGE_VALUE);

    return !!(pageVal && [EZLOGIC, NOTIFICATIONS, MESHBOTS_PAGE_VALUE, EZLO_PATHS.SYSTEM_HISTORY].includes(pageVal));
};
